<template>
  <div class="metadata-modal">
    <div class="body" ref="body">
      <type-field 
        class="grid-col-1-2 grid-row-1-2"
        :root="rootNode" 
        :type="formData.type" 
        :limitCompType="limitCompType"
      ></type-field>
      <div class="input-block grid-col-1-4 grid-row-2-3">
        <label>
          Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.PHY_ATTEND_LABEL"></tooltip>
        </label>
        <input type="text" v-model="label" name="content" required />
      </div>
      <div class="input-block grid-col-1-4 grid-row-3-4">
        <label>
          Paragraph text
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.PHY_ATTEND_PARAGRAPH"></tooltip>
        </label>
        <input type="text" v-model="paragraph" name="content" required />
      </div>
      <div class="input-block grid-col-1-4 grid-row-4-5">
        <label>
          Checkbox Label
          <span class="required">*</span>
          <tooltip :text="TOOLTIP_TEXT.PHY_ATTEND_CHECKBOX"></tooltip>
        </label>
        <input type="text" v-model="checkbox" name="content" required />
      </div>
    </div>
  </div>
</template>

<script src="/path/to/tinymce/tinymce.min.js"></script>

<script>
import { ROOT_NODE, TOOLTIP_TEXT } from "../mixins/constant-mixin";
import { PhyAttend, SPECIAL_COMP_PREFILL } from "../mixins/special-component-mixin";
import TypeField from "./TypeField.vue";
import Tooltip from "./Tooltip.vue";

export default {
  name: "PhyAttendModal",
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    state: {
      type: Object,
    },
    simpleView: {
      type: Boolean,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      formData: structuredClone(this.metadata),
      rootNode: ROOT_NODE.FIELDS,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
      label: SPECIAL_COMP_PREFILL.PhyAttend.LABEL,
      paragraph: SPECIAL_COMP_PREFILL.PhyAttend.PARAGRAPH,
      checkbox: SPECIAL_COMP_PREFILL.PhyAttend.CHECKBOX,
    };
  },
  watch: {
    metadata: function () {
      this.formData = structuredClone(this.metadata);
    },
    state: function () {
      if (this.state.closing) {
        if (this.state.saving) {
          this.$emit("insertNoCompType", this.fillFormData());
        } else {
          this.formData = structuredClone(this.metadata);
        }
      }
    },
  },
  components: {
    "type-field": TypeField,
    "tooltip": Tooltip,
  },
  methods: {
    fillFormData: function () {
      let formData = structuredClone(PhyAttend);
      let text = formData[0];
      let checkbox = formData[1];
      const html = `<p class="ql-align-justify"><strong>${this.label}</strong></p><p>${this.paragraph}</p>`;
      text.metadata.content = html;
      checkbox.metadata.content = this.checkbox;
      return formData;
    },
    getCompType: function (type) {
      return type.toLowerCase() === this.formData.type.toLowerCase();
    },
  },
};
</script>

<style scoped>
.metadata-modal {
  width: 100%;
}

.body {
  padding: 1rem 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 1rem;
}

.body > div {
  padding: 0 2rem;
}

.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.remove {
  text-align: center;
  background: #fff;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 0 9px 3px 9px;
  margin-top: 3px;
  cursor: pointer;
  font-weight: bolder;
}

.grid-col-1-2 {
  grid-column: 1 / 2;
}

.grid-col-1-4 {
  grid-column: 1 / 4;
}

.grid-row-1-2 {
  grid-row: 1 / 2;
}

.grid-row-2-3 {
  grid-row: 2 / 3;
}

.grid-row-3-4 {
  grid-row: 3 / 4;
}

.grid-row-4-5 {
  grid-row: 4 / 5;
}

.more-option {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #808080;
  text-align: center;
}

.more-option > legend {
  padding: 0 0.5rem;
}

.required {
  color: #f00;
}
</style>